import React from 'react';
import styled, { css } from 'styled-components';
import {
  arrayOf, bool, func, number, string, exact,
} from 'prop-types';
import {
  Button, Flex, Typography, Modal,
} from '@atoms';

const SpecialSizesModal = ({
  isModalOpen,
  onModalClose,
  sizes,
  onSizeSelect,
}) => {
  const memoizedSizes = sizes.map(({ name, id }) => (
    <Size padding="sm" marginTop="sm" onClick={onSizeSelect(id)} key={id}>
      <Typography>{name}</Typography>
    </Size>
  ));

  return (
    <Modal
      onTop
      isOpen={isModalOpen}
      ariaHideApp={false}
      onRequestClose={onModalClose}
      shouldCloseOnOverlayClick
    >
      <Flex column>
        <Typography marginBottom="xl2" weight="bold">What size is your special for?</Typography>
        {memoizedSizes}
        <Button.Rectangular
          fullWidth
          primaryInverted
          padding="md"
          onClick={onModalClose}
          marginTop="xl5"
        >
          <Typography size="lg">
            Cancel
          </Typography>
        </Button.Rectangular>
      </Flex>
    </Modal>
  );
};

const Size = styled(Flex)`
  ${({ theme: { color } }) => css`
    border-bottom: 1px solid ${color.warmGrey};
    width: 100%;
  `}
`;

SpecialSizesModal.propTypes = {
  sizes: arrayOf(exact({
    id: number,
    name: string,
    price: number,
  })).isRequired,
  onSizeSelect: func.isRequired,
  isModalOpen: bool.isRequired,
  onModalClose: func.isRequired,
};

export default SpecialSizesModal;
